export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/specky-boy-475b695b5c4a735e8e2e77220ba3c416.png";